module.exports = __webpack_public_path__ + "static/media/developing-cause-bgc.17ab3002.png";